import { render, staticRenderFns } from "./NewAgent.vue?vue&type=template&id=1b8ddcec&scoped=true"
import script from "./NewAgent.vue?vue&type=script&lang=js"
export * from "./NewAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ddcec",
  null
  
)

export default component.exports